module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_8011.276c5ae2.png";